import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'stars-notfound-page',
  templateUrl: './notfound.html',
  styleUrls: ['./notfound.scss']
})
export class NotFoundPageComponent {
  private location = inject(Location);

  goBack() {
    this.location.back();

    return false;
  }
}
